"use client";

import Script from "next/script";

const script = `
window.plausible = window.plausible || function() {
    (window.plausible.q = window.plausible.q || []).push(arguments);
};
`;

const config = {
  domain: "seoaipal.com",
  script:
    "https://analytics3.ricu.it/js/script.file-downloads.hash.outbound-links.pageview-props.revenue.tagged-events.js",
};

export const Analytics = () => {
  return (
    <>
      <Script defer data-domain={config.domain} src={config.script} />
      <Script
        id="plausible-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: script,
        }}
      />
    </>
  );
};
